module.exports = __webpack_public_path__ + "static/gruenflaeche-af9b110c47fd95c04b104e0fc219ce65.PNG";